// Service Worker Registration and Management

export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          // console.log('SW registered:', registration);

          // Check for updates every 30 seconds in production
          setInterval(() => {
            registration.update();
          }, 30000);

          // Handle updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New content available, auto-reload after a short delay
                  // In production, you might want to show a custom notification UI instead
                  // console.log('New version available! Reloading to update...');
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              });
            }
          });
        })
        .catch((_error) => {
          // console.error('SW registration failed:', error);
        });

      // Listen for reload messages from service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'RELOAD_REQUIRED') {
          // console.log('Chunk loading error detected, reloading...');
          // Clear all caches and reload
          if ('caches' in window && window.caches) {
            caches.keys().then((names) => {
              Promise.all(names.map((name) => caches.delete(name))).then(() => {
                window.location.reload();
              });
            });
          } else {
            // Directly reload without cache clearing
            location.reload();
          }
        }
      });
    });
  }
};

// Handle chunk loading errors at the application level
export const handleChunkLoadError = (error: Error): void => {
  // console.error('Chunk loading error:', error);
  
  // Check if it's a dynamic import error
  if (error.message && error.message.includes('Failed to fetch dynamically imported module')) {
    // Clear module cache and reload
    if ('caches' in window && window.caches) {
      caches.keys().then((names) => {
        Promise.all(names.map((name) => caches.delete(name))).then(() => {
          window.location.reload();
        });
      });
    } else {
      // Directly reload without cache clearing
      location.reload();
    }
  }
};

// Add global error handler for chunk loading errors
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('Failed to fetch dynamically imported module')) {
      event.preventDefault();
      handleChunkLoadError(event.reason);
    }
  });

  // Also handle regular errors
  window.addEventListener('error', (event) => {
    if (event.error && event.error.message && 
        event.error.message.includes('Failed to fetch dynamically imported module')) {
      event.preventDefault();
      handleChunkLoadError(event.error);
    }
  });
}